import axios from 'axios';

const { REACT_APP_API_URL } = process.env;

const axiosInstanse = axios.create({
  baseURL: REACT_APP_API_URL,
  timeout: 30000
});

// Use request interceptor to always read the latest token from localStorage
// instead of setting it once at creation time (which becomes stale after login/refresh)
axiosInstanse.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = token;
  }
  return config;
});

const handleTokenRefresh = (response) => {
  if (response?.data?.token && response?.data?.token !== null) {
    localStorage.setItem('token', response.data.token);
  }
};

export const getApi = async (path) => {
  try {
    const response = await axiosInstanse.get(path);
    handleTokenRefresh(response);
    return response;
  } catch (error) {
    console.error(`GET ${path} failed:`, error?.response?.status || error.message);
    return error?.response;
  }
};

export const postApi = async (path, data) => {
  try {
    const response = await axiosInstanse.post(path, data);
    handleTokenRefresh(response);
    return response;
  } catch (error) {
    console.error(`POST ${path} failed:`, error?.response?.status || error.message);
    return error?.response;
  }
};

export const EditApi = async (path, data) => {
  try {
    const response = await axiosInstanse.put(path, data);
    handleTokenRefresh(response);
    return response;
  } catch (error) {
    console.error(`PUT ${path} failed:`, error?.response?.status || error.message);
    return error?.response;
  }
};

export const deleteApi = async (path) => {
  try {
    const response = await axiosInstanse.delete(path);
    handleTokenRefresh(response);
    return response;
  } catch (error) {
    console.error(`DELETE ${path} failed:`, error?.response?.status || error.message);
    return error?.response;
  }
};

export const deleteManyApi = async (path, data) => {
  try {
    const response = await axiosInstanse.post(path, data);
    handleTokenRefresh(response);
    return response;
  } catch (error) {
    console.error(`DELETE_MANY ${path} failed:`, error?.response?.status || error.message);
    return error?.response;
  }
};
